import { Module } from 'vuex'
import { RootState } from '@/store/types'
import actions from '@/modules/product/store/actions'
import mutations from '@/modules/product/store/mutations'
import getters from '@/modules/product/store/getters'
import {ProductPagination, ProductPaginationParams, Product} from '@/modules/product'
import UnigestLanguage from '@/modules/product/model/UnigestLanguage';
import store from '@/store';
import {setCurrentMetadata, setCurrentTranslation} from '@/modules/seo/store/subscriptions';

interface ProductState {
    /**
     * Paginación actual obtenida desde la api
     */
    pagination: ProductPagination

    /**
     * Parámetros para la paginación de productos
     */
    paginationParams: ProductPaginationParams,

    /**
     * Indica si la paginación se esta cargando
     */
    loadingPagination: boolean,

    /**
     * Producto actualmente en edición
     */
    currentProduct: Product,

    /**
     * Idioma del producto seleccionado actualmente
     */
    currentLocale: string,

    /**
     * Indica si se ha de mostrar la imagen del producto a tamaño completo en
     * una ventana flotante.
     */
    showProductImage: boolean,

    /**
     * Indica si se ha de mostrar le modal de confirmación para guardar un producto
     */
    saveConfirm: boolean,

    /**
     * Lista de idiomas registrados en Unigest
     */
    unigestLanguages: UnigestLanguage[],
}

// Registra dos listeners
store.listen('product/product/current/set', setCurrentMetadata)
store.listen('product/product/locale/current/set', setCurrentTranslation)

const vuexModule: Module<ProductState, RootState> = {
    namespaced: true,
    actions,
    mutations,
    getters,
    state: {
        pagination: new ProductPagination(),
        paginationParams: { page: 1, recordsPerPage: 30},
        loadingPagination: false,
        currentProduct: new Product(),
        currentLocale: '',
        showProductImage: false,
        saveConfirm: false,
        unigestLanguages: [],
    },
}

export {
    ProductState,
    vuexModule as default,
}
